import { getToken, onMessage } from 'firebase/messaging';
import app, { messagingPromise } from './config';

const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

// Register service worker and fetch registration token. Returns null when unsupported.
export const getFcmRegistrationToken = async () => {
  const messaging = await messagingPromise;
  if (!messaging) return null;
  if (!vapidKey) {
    console.warn('Missing REACT_APP_FIREBASE_VAPID_KEY env for FCM');
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: registration });
    return token || null;
  } catch (err) {
    console.error('Error retrieving FCM token', err);
    return null;
  }
};

// Subscribe to foreground messages; no-op when unsupported.
export const onForegroundMessage = async (handler) => {
  const messaging = await messagingPromise;
  if (!messaging) return () => {};
  return onMessage(messaging, handler);
};

export default app;
